import { Component, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LanguageService } from 'src/app/services/account/language.service';
import { ModalOptionPanelComponent } from '../../modal-option-panel/modal-option-panel.component';

@Component({
  standalone: true,
  selector: 'app-eula',
  templateUrl: './eula.component.html',
  imports: [ModalOptionPanelComponent],
  styleUrls: ['./eula.component.scss']
})
export class EulaComponent {
  constructor(
    public languageService: LanguageService,
    @Optional() public dialogRef: MatDialogRef<EulaComponent> | null
  ) { }

}
